import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import FormAlert from "./FormAlert";
import { usePlayersByEvent, updateEventCompleteFalse } from "./../util/db";
import { Form } from "react-bootstrap";

function EventCompleteRoundFalseTd(props) {
  const {
    data: items,
    status: itemsStatus,
    error: itemsError,
  } = usePlayersByEvent(props.eventId);

  const [pending, setPending] = useState(false);
  const itemsAreEmpty = !items || items.length === 0;

  const onSubmit = (e) => {
    e.preventDefault();

    // Show pending indicator
    setPending(true);

    //update score in db
    updateEventCompleteFalse(props.eventId);

    //update pending to false
    setPending(false);
  };

  return (
    <>
      {itemsError && (
        <div className="mb-3">
          <FormAlert type="error" message={itemsError.message} />
        </div>
      )}

      {(itemsStatus === "loading" || itemsAreEmpty) && (
        <div className="py-5 px-3 text-center">
          {itemsStatus === "loading" && (
            <Spinner animation="border" variant="primary">
              <span className="sr-only">Loading...</span>
            </Spinner>
          )}

          {itemsStatus !== "loading" && itemsAreEmpty && (
            <div>No players yet</div>
          )}
        </div>
      )}

      {itemsStatus !== "loading" && items && items.length > 0 && (
        <div className="text-center">
          <div className="mb-3">
            Event is already complete. Click to reopen for modifications.
          </div>
          <Form onSubmit={onSubmit}>
            <Form.Group controlId="formUserId">
              <Form.Control type="hidden" defaultValue={props.eventId} />
            </Form.Group>
            <div className="d-flex justify-content-center">
              <Button
                style={{
                  background: "#28a745",
                  border: "none",
                  borderRadius: "8px",
                  padding: "12px 40px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                size="lg"
                type="submit"
                disabled={pending}
              >
                Reopen Event
                {pending && (
                  <Spinner
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden={true}
                    className="ml-2"
                  >
                    <span className="sr-only">Sending...</span>
                  </Spinner>
                )}
              </Button>
            </div>
          </Form>
        </div>
      )}
    </>
  );
}

export default EventCompleteRoundFalseTd;
